import { create } from 'zustand';

import type { DateFilterState } from '@/features/Commons/DatePresetFilter';
import type { HierarchyNodeData } from '@/features/InsightExplorer/components/InsightExplorerSidebar/HierarchyNavigator/HierarchyNavigator';
import {
  InsightExplorerByType,
  InsightExplorerViewType,
} from '@/features/InsightExplorer/types/constants';
import { getDateRangeByDateT, RangeUnit } from '@/utils/getDatePreset';

export type TreeDataState = {
  data: HierarchyNodeData[];
  map: Record<string, HierarchyNodeData>;
  initialized?: boolean;
};

export const initialDateState: DateFilterState = {
  dateRange: getDateRangeByDateT(RangeUnit.Daily, 2),
  rangeUnit: RangeUnit.Daily,
  presetItem: 2,
};

type State = {
  selectedNode: HierarchyNodeData | null;
  treeData: TreeDataState;
  by: InsightExplorerByType;
  view: InsightExplorerViewType;
  filterQueryFormats: StructuredFilterQueryFormatT[];
  searchValue: string;
  dateState: DateFilterState;
};

type Actions = {
  findNode: (id: string) => HierarchyNodeData | null;
  setState: StoreSetter<State>;
  initInsightExplorerStore: () => void;
};

const initialState: State = {
  selectedNode: null,
  treeData: {
    data: [],
    map: {},
    initialized: false,
  },
  by: InsightExplorerByType.TAXONOMY,
  view: InsightExplorerViewType.VOLUME,
  filterQueryFormats: [],
  searchValue: '',
  dateState: initialDateState,
};

const useInsightExplorerStore = create<State & Actions>((set, get) => ({
  ...initialState,
  setState: set,
  findNode: (id: string) => {
    const { treeData } = get();
    return treeData.map[id] || null;
  },
  initInsightExplorerStore: () => set(initialState),
}));

export default useInsightExplorerStore;
